import { FC, useMemo } from 'react';

import { ACCOUNT_CONTROL_PAGE_ROUTE } from 'utils/constants/app';

import { GridColumn, GridLayout, GridRow, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';
import { useDashboardRoute } from 'hooks/useDashboardRoute';

import { AccountCreate } from 'components/AccountCreate/AccountCreate';
import { PageContentHeader } from 'components/common/PageContentHeader/PageContentHeader';
import { Header } from 'components/Header/Header';

import { useSelector } from 'store/utils';

const TrlKeys = {
    title: {
        create: 'account.create.title',
        edit: 'account.edit.title',
    },
    breadcrumbs: {
        mainPage: 'accounts.create.backLink',
        accountControlPage: 'accounts.edit.backLink',
    },
};

export const AccountCreatePage: FC = () => {
    const accountId = useSelector((state) => state.accounts.accountId);
    const trl = useTrls();
    const dashboardRoute = useDashboardRoute();

    const breadcrumbsConfig = useMemo(
        () => [
            {
                to: dashboardRoute,
                children: trl(TrlKeys.breadcrumbs.mainPage),
            },
            {
                to: ACCOUNT_CONTROL_PAGE_ROUTE,
                children: trl(TrlKeys.breadcrumbs.accountControlPage),
            },
            { to: '#', children: trl(accountId ? TrlKeys.title.edit : TrlKeys.title.create) },
        ],
        [accountId, dashboardRoute, trl]
    );

    return (
        <>
            <Header />
            <PageContentHeader
                breadcrumbsConfig={breadcrumbsConfig}
                title={trl(accountId ? TrlKeys.title.edit : TrlKeys.title.create)}
                vSpacingBottom={24}
            />
            <GridLayout>
                <GridRow>
                    <GridColumn xs={4} s={8} m={10} l={8}>
                        <AccountCreate />
                        <VSpacing default={48} />
                    </GridColumn>
                </GridRow>
            </GridLayout>
        </>
    );
};
